import React from "react";
import { Modal } from "antd";

import Iconfont from "@components/iconfont/iconfont";

/**
 * 官网价格页入口没有引入 antd 基础样式（antd/dist/antd.less），
 * `.ant-modal-mask` 拿不到 position/inset，只设 backgroundColor 会是 0 尺寸的空 div。
 * 这里用 maskStyle 在行内把遮罩补齐，保证弹窗出现时整屏铺 #000 50% 遮罩。
 */
const MASK_STYLE = {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  /* 与 .official-price-subscribe-modal.ant-modal-wrap 的 z-index 一致；
   * 遮罩在 DOM 中位于 wrap 之前，同层级下弹窗仍在其上方。
   * 需要盖住官网固定导航（.nav z-index: 100）与对比表吸顶头（z-index: 99）。 */
  zIndex: 1000,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
};

export default function SubscribePackageErrorModal({
  emptyVisible,
  onCancel,
  onCreateTeam,
}) {
  console.log("emptyVisible", emptyVisible);

  return (
    <Modal
      visible={emptyVisible}
      width={380}
      centered
      footer={null}
      closable={false}
      destroyOnClose
      wrapClassName="official-price-subscribe-modal official-price-subscribe-modal--empty"
      maskStyle={MASK_STYLE}
      onCancel={onCancel}
    >
      <div className="official-price-subscribe-modal__header official-price-subscribe-modal__header--empty">
        <div className="official-price-subscribe-modal__title">
          订阅套餐错误
        </div>
        <button
          type="button"
          className="official-price-subscribe-modal__close"
          aria-label="关闭"
          onClick={onCancel}
        >
          <Iconfont type="icon-a-guanbixi" />
        </button>
      </div>
      <div className="official-price-empty-modal__body">
        当前暂无具有管理权限的私域
      </div>
      <div className="official-price-empty-modal__footer">
        <button
          type="button"
          className="official-price-empty-modal__button"
          onClick={onCreateTeam}
        >
          创建私域
        </button>
      </div>
    </Modal>
  );
}
